export class AppUrls {
    public static signInUrl = 'sign-in';
    public static homeUrl = 'home';
    public static dataDropUrl = 'data-drop';
    public static hotelGptUrl = 'hotel-gpt';
    public static noAccessUrl = 'no-access';
}
